import request from '../request'
export default {
  // 订单查询
  listOrder: function (param) {
    return request.Post('shop/listOrder', {
      orderStatus: param.orderStatus || '',
      id: param.id,
      orderNo: param.orderNo
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  cleanHistoryGoodsName (parameter) {
    return request.Post('shop/cleanHistoryGoodsName', {})
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  selectGoodsCheckHotConfig () {
    return request.Post('shop/goodsCheckHotConfig')
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  shopGetById: function (param) {
    return request.Post('shop/getById', {
      id: param
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  goods: function (param, pagingData) {
    return request.Post('shop/goods', {
      goodsName: param.goodsName
    }, {
      currentPage: pagingData.currentPage || '',
      pageSize: pagingData.pageSize || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  goods2: function (param, pagingData) {
    return request.Post('shop/goodsContainerLoad', {
      goodsName: param.goodsName
    }, {
      currentPage: pagingData.currentPage || '',
      pageSize: pagingData.pageSize || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 商品分类以及商品列表
  pageCategory: function () {
    return request.Post('shop/listCategory', {
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  pageCategory2: function () {
    return request.Post('shop/listCategorys', {
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 商品列表，传分类id
  listCategoryById: function (params) {
    return request.Post('shop/listCategoryById', params)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 拼箱列表
  listCategoryContainerLoadById: function (params) {
    return request.Post('shop/listCategoryContainerLoadById', params)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  createOrderBrowsing: function (param) {
    return request.Post('shop/createOrderBrowsing', {
      orderPrice: param.orderPrice || '',
      goodsName: param.goodsName || '',
      imgPath: param.imgPath || '',
      remark: param.remark || '',
      orderItemList: param.orderItemList || []
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 拼箱购物车
  addCartGoods2: function (param) {
    return request.Post('shop/addCartGoods', {
      // goodsId: param.id || '',
      category: param.category || '',
      // qty: param.qty || '',
      imgPath: param.goodsImg,
      containerLoadImg: param.containerLoadImg,
      containerLoadName: param.containerLoadName,
      containerLoad: param.containerLoad,
      // goodsName: param.goodsName,
      // price: param.price,
      // specificationQty: param.specificationQty,
      mainGoodsAddFlag: param.mainGoodsAddFlag,
      containerLoadGoodsList: param.containerLoadGoodsList || [],
      miniBuyQty: param.miniBuyQty
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 添加购物车
  addCartGoods: function (param) {
    return request.Post('shop/addCartGoods', {
      goodsId: param.id || '',
      category: param.category || '',
      qty: param.qty || '',
      imgPath: param.goodsImg,
      goodsName: param.goodsName,
      price: param.price,
      containerLoad: param.containerLoad,
      specificationQty: param.specificationQty,
      mainGoodsAddFlag: param.mainGoodsAddFlag,
      minCartGoodsList: param.minCartGoodsList || [],
      miniBuyQty: param.miniBuyQty
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 购物车内点击加减按钮改变数量
  // {goodsId:商品ID,opFlag(标记 -- 1-加,2-减),category:类别ID}
  changeCartGoodsNum: function (param) {
    return request.Post('shop/changeCartGoodsNum', {
      goodsId: param.goodsId || '',
      category: param.category || '',
      qty: param.miniBuyQty || '',
      opFlag: param.opFlag || 0,
      miniBuyQty: param.miniBuyQty || '',
      containerLoad: param.containerLoad || '',
      minCartGoodsList: param.minCartGoodsList || []
      // qty: param.qty || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  selOrderRemark: function (params) {
    return request.Post('shop/selOrderRemark', params)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 拼箱
  changeCartGoodsNum2: function (param) {
    return request.Post('shop/changeCartGoodsNum', {
      category: param.category || '',
      opFlag: param.opFlag || 0,
      miniBuyQty: param.miniBuyQty || '',
      // containerLoad: param.containerLoad || '',
      containerLoadName: param.containerLoadName || '',
      containerLoadGoodsList: param.containerLoadGoodsList || []
      // qty: param.qty || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  // 删除购物车
  delCartGoods: function (param) {
    return request.Post('shop/delCartGoods', param)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  shopCartList: function (param) {
    return request.Post('shop/shopCartList')
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  listOrder2: function (params) {
    return request.Post('shop/listCategoryByIdChangeOrder', params)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  Slideshow: function (param) {
    return request.Post('shop/Slideshow')
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }
}
